module.exports = __webpack_public_path__ + "img/reaper_teleport--join-crop.d3307f20.gif";